import React from 'react';
import type { Order } from '@/types/orderTypes';
import styles from './OrderCard.module.css';
import {
  getOrderDisplayIdentifier,
  getOrderDisplaySubIdentifier,
} from '@/helpers/orderHelpers';
import { ScaledText } from '@/components/scaled-text/ScaledText';

interface OrderCardProps {
  order: Order;
  isFirstRowReady?: boolean;
}

export const OrderCard: React.FC<OrderCardProps> = ({
  order,
  isFirstRowReady = false,
}) => {
  const subtitle = getOrderDisplaySubIdentifier(order);
  const displayName = getOrderDisplayIdentifier(order);

  return (
    <div
      className={styles.orderCard}
      data-status={order.status}
      data-first-row-ready={isFirstRowReady}
      data-testid={`order-card-${order.id}`}
    >
      <ScaledText
        testid="order-primary-identifier"
        text={displayName}
        fontSize={'90px'}
      />
      {subtitle && (
        <ScaledText
          testid="order-secondary-identifier"
          text={subtitle}
          fontSize="24px"
        />
      )}
    </div>
  );
};
